import React from 'react'
import { ReactComponent as BookSVG } from 'resources/graphics/book.svg'
import { ShelfType } from 'store/services/Library'
import { FavouriteButton } from 'components/FavouriteButton'

import styles from './ShelfEmptyState.module.scss'

type ShelfEmptyStateProps = {
  shelfType?: ShelfType
}

export const ShelfEmptyState: React.FC<ShelfEmptyStateProps> = ({ shelfType }) => {
  switch (shelfType) {
    case ShelfType.COMPLETED:
      return (
        <div className={styles.container}>
          <BookSVG className={styles.bookIcon} />
          <p className={styles.title} style={{ fontSize: '12px' }}>
            Completed
          </p>
        </div>
      )

    case ShelfType.FAVORITE:
      return (
        <div className={styles.container}>
          <div className={styles.title} style={{ verticalAlign: 'bottom', fontSize: '18px' }}>
            Click <FavouriteButton disable isPink size="small" /> to save a story to your favourites!
          </div>
        </div>
      )

    default:
      return null
  }
}
